import React, { useState, useEffect, FunctionComponent } from 'react'
import { UpdateBanner as UiUpdateBanner } from '@follow-health/fw_ui_library/dist/features/app/features/AppUpdate/components/UpdateBanner'

import styles from './UpdateBanner.module.scss'
import { NewVersionLabel } from '../../../../constants'

export const UpdateBanner: FunctionComponent = () => {
  const [outdated, setOutdated] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [swRegistration, setSwRegistration] = useState<ServiceWorkerRegistration>()

  const onUpdate = (event) => {
    setOutdated(true)
    setSwRegistration(event.detail)
  }

  useEffect(() => {
    document.addEventListener(NewVersionLabel, onUpdate)
    navigator.serviceWorker.addEventListener('controllerchange', onServiceWorkerChange)

    return () => {
      document.removeEventListener(NewVersionLabel, onUpdate)
      navigator.serviceWorker.removeEventListener('controllerchange', onServiceWorkerChange)
    }
  }, [])

  const onServiceWorkerChange = () => {
    window.location.reload()
  }

  function enableNewServiceWorker() {
    // "Skip waiting" dit à la nouvelle version du service worker de s'activer et désactive l'ancienne
    if (swRegistration?.waiting) {
      setIsUpdating(true)
      swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' })
    } else {
      window.location.reload()
    }
  }

  return (
    <UiUpdateBanner
      visible={outdated}
      isUpdating={isUpdating}
      onUpdate={enableNewServiceWorker}
      onRemindLater={() => setOutdated(false)}
      className={styles.banner}
    />
  )
}
